<!--
 * @Author: tiandi
 * @Date: 2022-01-19 16:01:07
 * @LastEditTime: 2022-04-06 13:58:06
 * @LastEditors: Please set LastEditors
 * @Description: 工作台-质量改进评价
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/index.vue
-->
<template>
  <section>
    <div
      slot="funBtn"
      class="flex mt-10"
      :class="xfwdList.length > 1 ? 'tab-btn' : ''"
    >
      <w-button
        v-if="isOpenMulti"
        class="ml-10"
        size="small"
        type="primary"
        @click="mulPJ"
        >批量评价
      </w-button>
    </div>

    <w-table
      ref="singleSelect"
      v-win-loading="loading"
      :data="tableData"
      highlight-current-row
      border
      class="mt-5"
      stripe
      :height="tableHeight"
      :span-method="rowspanMethod"
      @selection-change="handleSelectionChange"
    >
      <w-table-column
        v-if="isOpenMulti"
        type="selection"
        prop="select_id"
        align="center"
        width="50"
        :selectable="selected"
      />
      <w-table-column
        type="index"
        prop="idx"
        label="序号"
        width="65"
        align="center"
      >
        <template slot-scope="scope">
          {{
            listQuery.PageSize * (listQuery.PageIndex - 1) + scope.row.idx + 1
          }}
        </template>
      </w-table-column>

      <w-table-column
        v-for="co in tableColumns"
        :key="co.key"
        :prop="co.key"
        :label="co.name"
        :align="co.align"
        :width="co.width"
      >
        <template slot-scope="scope">
          <span v-if="co.key == 'ZGZTMC'">
            <!-- 如果有stepItem则展示弹框(待整改这些状态不展示，所以由后端的stepItem控制) -->
            <template
              v-if="scope.row.stepItem && scope.row.stepItem.length > 0"
            >
              <w-popover v-model="visible[scope.$index]" placement="top-start">
                <section slot="reference">
                  <!-- 已评价 -->
                  <w-tag
                    v-if="scope.row.ZGZT >= 40"
                    type="success"
                    :plain="false"
                    style="background-color: #5eb95e"
                    size="small"
                    >{{ scope.row.ZGZTMC }}
                  </w-tag>
                  <!-- 待评价 -->
                  <w-tag
                    v-else-if="scope.row.ZGZT == 30"
                    type="warning"
                    :plain="false"
                    size="small"
                    >{{ scope.row.ZGZTMC }}
                  </w-tag>
                  <!-- 待整改 -->
                  <w-tag v-else type="info" :plain="false" size="small">
                    {{ scope.row.ZGZTMC }}
                  </w-tag>
                </section>
                <section
                  :style="{
                    width: `${(scope.row.stepItem.length || 1) * 150}px`
                  }"
                >
                  <w-steps :active="scope.row.step">
                    <w-step
                      v-for="(step, stepindex) in scope.row.stepItem"
                      :key="`${scope.$index}_${stepindex}`"
                      :title="step"
                    ></w-step>
                  </w-steps>
                </section>
              </w-popover>
            </template>
            <template v-else>
              <section>
                <!-- 已评价 -->
                <w-tag
                  v-if="scope.row.ZGZT >= 40"
                  type="success"
                  :plain="false"
                  style="background-color: #5eb95e"
                  size="small"
                  >{{ scope.row.ZGZTMC }}
                </w-tag>
                <!-- 待评价 -->
                <w-tag
                  v-else-if="scope.row.ZGZT == 30"
                  type="warning"
                  :plain="false"
                  size="small"
                  >{{ scope.row.ZGZTMC }}
                </w-tag>
                <!-- 待整改 -->
                <w-tag v-else type="info" :plain="false" size="small">
                  {{ scope.row.ZGZTMC }}
                </w-tag>
              </section>
            </template>
          </span>
          <span v-else-if="co.key == 'ZZJGMC'">
            <w-row
              v-for="(item, index) in scope.row.wtList"
              :key="index"
              class="table-inner-row"
            >
              {{ item.ZZJGMC }}
            </w-row>
          </span>
          <span v-else-if="co.key == 'JCSJ'">
            <w-row
              v-for="(item, index) in scope.row.wtList"
              :key="index"
              class="table-inner-row"
            >
              {{ item.JCSJ ? item.JCSJ.split(' ')[0] : '' }}
            </w-row>
          </span>

          <!-- 问题维度展示 -->
          <span
            v-else-if="
              co.key == 'KFYY' ||
              co.key == 'KFMC' ||
              co.key == 'BZMC' ||
              co.key == 'XMMC' ||
              co.key == 'BDMC'
            "
          >
            <w-row
              v-for="(item, index) in scope.row.wtList"
              :key="index"
              class="table-inner-row"
            >
              <w-tooltip
                width="200px"
                theme="dark"
                :content="item[co.key]"
                placement="top-start"
              >
                <div
                  slot="reference"
                  class="tooltip-reference table-inner-row-text"
                >
                  {{ item[co.key] }}
                </div>
              </w-tooltip>
            </w-row>
          </span>
          <span v-else-if="co.key === 'CJSJ'">
            {{ scope.row.CJSJ ? scope.row.CJSJ.split(' ')[0] : '' }}
          </span>
          <span v-else>
            {{ scope.row[co.key] }}
          </span>
        </template>
      </w-table-column>

      <w-table-column
        label="操作"
        prop="op"
        width="120"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <template>
            <!-- 存在多次评价，已评价了的也可以再次评价 -->
            <w-button type="text" @click="toView(scope.row)"> 查看 </w-button>
            <w-button
              v-if="scope.row.SFDJ == 1"
              type="text"
              :disabled="!scope.row.isCanSQ"
              class="red-botton"
              @click="judgeSQ(scope.row)"
            >
              评价申请
            </w-button>
            <w-button
              v-else
              type="text"
              :disabled="!scope.row.isCanPJ"
              @click="judgeAction(scope.row)"
            >
              评价
            </w-button>
            <w-button
              type="text"
              :disabled="!scope.row.isCanRollback"
              @click="rollBack(scope.row)"
            >
              撤销
            </w-button>
          </template>
        </template>
      </w-table-column>
    </w-table>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { pageSizes } from '@/common/settings/pageSettings'
import { DownFile } from '@/common/utils/download'
import ApplyDialog from '@/common/components/Dialog/ApplyDialog.vue'
import JudgeDailog from '@/apps/modules/qc-rectification/qualityImprovementEvaluation/_components/dialog/detailDialog.vue'

export default {
  name: 'workBenchGZPJ',
  components: {},
  props: {
    cfxh: {
      type: Number,
      default: () => 0
    },
    pjzkjb: {
      type: String,
      default: () => ''
    },
    orgid: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      UserInfo: {},
      applyData: {},
      wdType: '20',
      pageSizes: pageSizes,
      PageSize: 20,
      PageIndex: 1,
      config: {
        select: false
      },
      tableColumns: [
        {
          name: '状态',
          key: 'ZGZTMC',
          width: 'auto',
          align: 'center',
          keepChoosing: false,
          width: '160'
        },
        {
          name: '受检科室',
          key: 'ZZJGMC',
          width: '200',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '督查时间',
          key: 'JCSJ',
          width: '110',
          align: 'center',
          keepChoosing: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          width: '400',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '检查项目',
          key: 'XMMC',
          width: '400',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '质量标准',
          key: 'BZMC',
          width: '400',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          width: '400',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '扣分原因',
          key: 'KFYY',
          width: '300',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '备注',
          key: 'MEMO',
          width: '160',
          align: 'center',
          keepChoosing: false
        },
        {
          name: '整改人',
          key: 'ZGR_MC',
          width: '100',
          align: 'center',
          keepChoosing: false
        },
        {
          name: '原因分析',
          key: 'YYFX',
          width: '200',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '整改措施',
          key: 'ZGCS',
          width: 'auto',
          width: '200',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '改进效果',
          key: 'GJXGMC',
          width: '100',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '评价内容',
          key: 'GZPJ',
          width: '200',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '评价人',
          key: 'PJRMC',
          width: '120',
          align: 'left',
          keepChoosing: false
        },
        {
          name: '评价时间',
          key: 'PJSJ',
          width: '120',
          align: 'center',
          keepChoosing: false
        }
      ],
      defaultColumns: [], //用作备份原来的列
      tableData: [],
      currentRow: null,
      listQuery: {
        PageIndex: 1,
        PageSize: 15,
        total: 0,
        StartTime: '',
        EndTime: '',
        ZKJB: '',
        ORGID: '',
        JHMC: '',
        XFZT: '',
        WCQK: '',
        XFWD: 20
      },
      searchKeyInfo: {
        name: '', // searchKey-名称
        onlySearch: true,
        hide: false
      },
      insertAuth: true, //新增按钮权限
      loading: false,
      refresh: false, //用于刷新
      tableHeight: 'calc(100vh - 100px)',
      xfwdList: [{ XFWD: 20, XFWDMC: '质量标准' }],
      selectObj: [],
      isOpenMulti: true,
      xfwd: 20,
      visible: [],
      ztActive: []
    }
  },
  computed: {
    ...mapState('rectification', [''])
  },
  created() {
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.defaultColumns = this.tableColumns
    this.getDataList()
    this.getxtmj()
    this.GetSxkzList()
  },
  methods: {
    ...mapMutations('plan', ['SET_ISREFRESH_TABLE']),
    GetSxkzList() {
      this.$requestApi('GetSxkzList', {}).then((res) => {
        if (res.success) {
          this.applyData = res.data.DataList.find((i) => i.CJDM == 'ZLGJPJ')
        } else {
          this.$msg(res.message)
        }
      })
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    selected(row, index) {
      if (!row.isCanPJ) {
        return false
      } else {
        return true
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.selectObj = val
    },
    getxtmj() {
      let that = this
      that.$requestApi('GetXTMJList', { Mjdm: '1095,1193' }).then((res) => {
        if (res.success) {
          // 批量评价不在由参数控制
          that.status1095 = res.data.find((m) => m.MJDM == 1095).JLZT
          if (that.status1095 == '0') {
            that.isOpenMulti = false
          }
          if (that.status1095 == '1') {
            that.isOpenMulti = true
          }

          if (
            that.status1095 == '2' &&
            (this.pjzkjb == 1001 || this.pjzkjb == 1002)
          ) {
            that.isOpenMulti = false
          } else {
            this.isOpenMulti = true
          }
          that.xfwd = res.data.find((m) => m.MJDM == 1193).JLZT || 20
          that.toggleShow()
        }
      })
    },

    toggleShow() {
      switch (this.xfwd) {
        case '1': // 扣分标准，显示全部
          break
        case '2':
          this.tableColumns.splice(6, 1)
          break
        case '3':
          this.tableColumns.splice(5, 2)
          break
        case '4':
          this.tableColumns.splice(4, 3)
          break
        default:
          break
      }
    },
    // 质量改进评价列表
    getDataList() {
      let that = this
      let obj = {
        PageIndex: 1,
        PageSize: 999,
        UserId: that.UserInfo.UserId,
        CFXH: this.cfxh,
        ZKJB: this.pjzkjb,
        ORGID: this.orgid
      }

      this.loading = true
      this.SET_ISREFRESH_TABLE(false)
      this.$requestApi('GetGJPJList', obj)
        .then((res) => {
          this.loading = false

          if (res.success) {
            let data = []
            res.data.forEach((val, index) => {
              if (val && val.pjList && val.pjList.length > 0) {
                val.pjList.forEach((pj) => {
                  let obj = { ...val }
                  obj.idx = index
                  // 不要交换pj 和obj顺序，要以obj的字段为准
                  obj = { ...pj, ...obj }
                  data.push(obj)
                })
              } else {
                data.push({ ...val, idx: index })
              }
            })
            this.tableData = data
            this.listQuery.total = res.total
          }
        })
        .catch((err) => {
          this.loading = false
        })
    },

    exportFile(type) {
      let that = this
      let obj = {
        UserId: this.UserInfo.UserId,
        ZKJB: that.listQuery.ZKJB,
        StartTime: that.listQuery.StartTime,
        EndTime: that.listQuery.EndTime,
        PageIndex: that.listQuery.PageIndex,
        PageSize: that.listQuery.PageSize,
        ORGID: that.listQuery.ORGID,
        UserId: that.UserInfo.UserId,
        ZGZT: that.listQuery.ZGZT || '',
        GJXG: that.listQuery.GJXG || '',
        BDDM: that.listQuery.BDDM || '',
        JCKS: that.listQuery.JCKS || '',
        XFWD: that.listQuery.XFWD || '20',
        FileType: type,
        ExportColumns: JSON.stringify(this.tableColumns)
      }
      DownFile('NQCS/Download?act=ExportGZPJ', obj)
    },
    print() {},
    formatDate(val) {
      return this.moment(val).format('YYYY-MM-DD')
    },
    mulPJ() {
      if (this.selectObj.length == 0) {
        this.$msg('请选择数据!')
        return
      }
      if (this.selectObj.some((m) => m.SFDJ === 1)) {
        this.$msg('需要申请评价的数据不能进行批量评价!')
        return
      }
      let that = this
      let wtxhArr = []
      that.selectObj.forEach((item) => {
        let flag = item.wtList.map((m) => {
          return m.WTXH
        })
        wtxhArr = wtxhArr.concat(flag)
      })
      let wtxhs = wtxhArr.join(',')
      let pjzkjbs = that.selectObj.map((m) => m.PJZKJB).join(',')
      if (this.selectObj.length > 1) {
        this.$requestApi('GetPJDetailListByWtxh', { wtxhs: wtxhs }).then(
          (res) => {
            // 如果有没有保存的数据，不能进行保存
            if (res.data) {
              let noSubmitList = res.data.filter((m) => {
                return m.SFPJ == 0 && m.SFZP == 0
              })
              // 校验是否可以批量去评价
              if (noSubmitList.length > 1) {
                for (let index = 1; index < noSubmitList.length; index++) {
                  const nowItem = noSubmitList[index]
                  const lastItem = noSubmitList[index - 1]
                  if (
                    nowItem.GJXGDM != lastItem.GJXGDM ||
                    nowItem.GZPJ != lastItem.GZPJ ||
                    nowItem.PJSJ != lastItem.PJSJ ||
                    nowItem.PJRDM != lastItem.PJRDM ||
                    nowItem.SHRDM != lastItem.SHRDM
                  ) {
                    this.$Confirm(
                      '部分数据已存在评价记录，不能进行批量评价操作',
                      '提示',
                      {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        showClose: false,
                        closeOnClickModal: false,
                        type: 'warning'
                      }
                    ).then(() => {
                      that.$emit('close', { type: false })
                    })
                    return
                  }
                }
              }
              // 跳转评价
              that.judgeAction({
                WTXH: wtxhs,
                PLFXDM: '',
                FXXH: '',
                PJZKJB: pjzkjbs
              })
            }
          }
        )
      } else {
        that.judgeAction({
          WTXH: wtxhs,
          PLFXDM: '',
          FXXH: '',
          PJZKJB: pjzkjbs
        })
      }
    },
    judgeAction(row) {
      let _sef = this
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.7

      let params = {
        wtxhs: row.WTXH.toString(),
        pjzkjb: row.PJZKJB
      }

      this.$dlg.modal(JudgeDailog, {
        title: '评价',
        width: width,
        height: height,
        params: params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.getDataList()
          }
        },
        cancelCallback: () => {}
      })
    },
    judgeSQ(row) {
      let _sef = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.6
      let dialog = ApplyDialog
      let zkjbTemp =
        row.ZKJB == 1001
          ? '三级质控'
          : row.ZKJB == 1002
          ? '二级质控'
          : '一级质控'
      let zzjgmc =
        row.wtList && row.wtList.length > 0
          ? [
              ...new Set(
                row.wtList.map((item) => {
                  return item.ZZJGMC
                })
              )
            ].join(',')
          : ''
      let BDMC =
        row.wtList && row.wtList.length > 0
          ? [
              ...new Set(
                row.wtList.map((item) => {
                  return item.BDMC
                })
              )
            ].join(',')
          : ''
      let params = {
        dataList: this.applyData,
        row,
        sqnr: `【${zkjbTemp}】 【${BDMC}】 【${zzjgmc}】 【${row.JCZ || ''}】 ${
          this.applyData.CJMC
        }操作`
      }
      this.$dlg.modal(dialog, {
        title: `超期操作申请`,
        width: width,
        height: height,
        params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.getDataList()
          }
        },
        cancelCallback: () => {}
      })
    },
    toView(row) {
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.9
      let params = {
        wtxhs: row.WTXH.toString(),
        readOnly: true,
        pjzkjb: row.PJZKJB
      }
      this.$dlg.modal(JudgeDailog, {
        title: `查看`,
        width: width,
        height: height,
        params,
        callback: (data) => {},
        cancelCallback: () => {}
      })
    },
    rollBack(row) {
      this.$Confirm('是否撤销评价', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('RollBackPJ', {
            plfxdm: row.PLFXDM,
            zkjb: row.RollZKJB
          }).then((res) => {
            if (res.success) {
              this.$msg('撤销成功！', 'success')
              this.getDataList()
            }
          })
        })
        .catch(() => {})
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod({ row, column, rowIndex, columnIndex }) {
      let tableData = this.tableData // table的原始数据
      // 合并规则 column列名，condition：column合并的条件列，只有condition所有列相等才合并column列
      const mergeColumn = [
        { colmun: 'select_id', condition: ['idx'] },
        { colmun: 'idx', condition: ['idx'] },
        { colmun: 'ZGZTMC', condition: ['idx'] },
        { colmun: 'ZZJGMC', condition: ['idx'] },
        { colmun: 'JCSJ', condition: ['idx'] },
        { colmun: 'BDMC', condition: ['idx'] },
        { colmun: 'XMMC', condition: ['idx'] },
        { colmun: 'BZMC', condition: ['idx'] },
        { colmun: 'KFMC', condition: ['idx'] },
        { colmun: 'KFYY', condition: ['idx'] },
        { colmun: 'JCZ', condition: ['idx'] },
        { colmun: 'QTJCZ', condition: ['idx'] },
        { colmun: 'ZGLX', condition: ['idx'] },
        { colmun: 'XFR', condition: ['idx'] },
        { colmun: 'XFSH', condition: ['idx'] },
        { colmun: 'ZGR_MC', condition: ['idx'] },
        { colmun: 'YYFX', condition: ['idx'] },
        { colmun: 'ZGCS', condition: ['idx'] },
        { colmun: 'GJXGMC', condition: ['idx'] },
        { colmun: 'op', condition: ['idx'] }
      ]
      // 需要合并的列名
      const fields = mergeColumn.map((m) => m.colmun)

      // 比较函数，条件符合返回true，条件不成立返回false
      let compare = (pre, next, mergeItem) => {
        for (let i = 0; i < mergeItem.condition.length; i++) {
          const item = mergeItem.condition[i]
          if (pre[item] != next[item]) {
            return false
          }
        }
        return true
      }

      const cellValue = row[column.property]
      // cellValue为空时也进行比较
      if (fields.includes(column.property)) {
        const prevRow = tableData[rowIndex - 1]
        let nextRow = tableData[rowIndex + 1]
        let condition = mergeColumn.find((m) => m.colmun == column.property)
        if (prevRow && compare(prevRow, row, condition)) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && compare(row, nextRow, condition) && condition) {
            nextRow = tableData[++countRowspan + rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.option-zoom {
  margin-top: 16px;
  text-align: right;
}
.option-zoom .w-button + .w-button {
  margin-left: 16px;
}
.table-container {
  background-color: white;
}
.tool-container {
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-container {
  background-color: white;
  padding: 10px;
}

.table-inner-row {
  min-height: 40px;
  // line-height: 20px;
  padding: 0 2px;
  align-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid #c9c9c9;
  }
  &-text {
    flex: auto;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /*这里可以设置文本显示的行数*/
    overflow: hidden;
    vertical-align: middle;
  }
}
/deep/ .w-table .cell {
  padding: 0 4px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}
/deep/ .wn-table-template__funBtn {
  position: relative;
}
.tab-btn {
  position: absolute;
  right: 10px;
  top: 0px;
  z-index: 100;
}
</style>
